export default __webpack_public_path__ + "static/media/dashboard_2.b3c321cd.png";